export default function sanitizeTitle(title) {
    if(!title){
        return '';
    }
    var slug = "";
    // Change to lower case
    var titleLower = title.toLowerCase();
    // Letter "e"
    slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
    // Letter "c"
    slug = slug.replace(/ç/gi, 'c');
    // Letter "a"
    slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
    slug = slug.replace(/ä/gi, 'ae');
    // Letter "o"
    slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
    slug = slug.replace(/ö/gi, 'oe');
    // Letter "u"
    slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
    slug = slug.replace(/ü/gi, 'ue');
    // Letter "d"
    slug = slug.replace(/đ/gi, 'd');
    // Trim the last whitespace
    slug = slug.replace(/\s*$/g, '');
    // Change whitespace to "-"
    slug = slug.replace(/\s–\s/g, '-');
    slug = slug.replace(/\s–\s/g, '-');
    slug = slug.replace(/\s+/g, '-');
    // Special Chars
    slug = slug.replace(/&|%|:/gi, '');
    slug = slug.replace('?', '');
    slug = slug.replace(/\//gi, '-');
    // Replace slash with dash
    slug = slug.replace('/', '-');
    // Reduce multiple dashes
    slug = slug.replace(/----/gi, '-');
    slug = slug.replace(/---/gi, '-');
    slug = slug.replace(/--/gi, '-');

    return slug;
}